var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',[_c('PowerApp',{attrs:{"app":_vm.app,"entrypoint":_vm.appConfig.onboarding,"dist":_vm.settings.dist,"noRouter":"","config":_vm.config},on:{"onboardingSuccess":_vm.onboardingSuccess,"save":_vm.saveAppSettings}})],1):_c('b-skeleton',{attrs:{"width":"100%","height":"250px","animation":"throb"}})
}
var staticRenderFns = []

export { render, staticRenderFns }